// extracted by mini-css-extract-plugin
export default {"modalContainer":"r-","fadeIn":"s-","img":"t-","fadeInImg":"u-","greeting":"v-","fadeInGreeting":"w-","imgWrapper":"x-","name":"y-","fadeInName":"z-"};
    if(module.hot) {
      // 1713969938187
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  